import styled from '@emotion/styled';

const FormTitle = styled.h1`
  color: #515359;
`;

export const SubTitle = styled.div`
  color: #515359;
  padding-bottom: 24px;
`;

export default FormTitle;
